import React from 'react';
import { motion } from 'framer-motion';
import { reasons } from '../data/reasons';
import { Reveal } from './Reveal';
import { Eyebrow } from './Eyebrow';
const CRAFT_IMAGE = 'https://cdn.magicpatterns.com/patterns/generated-images/5196173d-1a83-46b7-ac7f-f6061b47d226.jpg';
export function WhyChooseUs() {
  return <section id="about" className="bg-white py-24 sm:py-32" data-id="element-367" data-mp="u6cgn75ejaeq">
      <div className="mx-auto grid max-w-[1400px] gap-14 px-5 sm:px-8 lg:grid-cols-[0.85fr_1.15fr] lg:gap-20" data-id="element-368" data-mp="g7w95dzptfvj">
        <div className="lg:sticky lg:top-28 lg:self-start" data-id="element-369" data-mp="l78v7wiriix2">
          <Reveal data-id="element-370" data-mp="l4mp81bisbgy">
            <Eyebrow data-id="element-371" data-mp="76y54vpa18cy">Why Unbelievable</Eyebrow>
            <h2 className="mt-6 font-display text-[clamp(2.1rem,4.6vw,3.6rem)] leading-[1.02] tracking-[-0.02em] text-navy-900" data-id="element-372" data-mp="789h3isvlmf5">
              Why Homeowners Choose
              <span className="block italic text-brass-dark" data-id="element-373" data-mp="21kfu8n5byda3">Unbelievable.</span>
            </h2>
          </Reveal>
          <Reveal delay={0.12} data-id="element-374" data-mp="25mudv9gtph2f">
            <div className="mt-9 overflow-hidden rounded-2xl" data-id="element-375" data-mp="25lrnd2nexgn1">
              <motion.img src={CRAFT_IMAGE} alt="Craftsman sanding freshly primed trim during a home renovation" loading="lazy" initial={{
              scale: 1.12
            }} whileInView={{
              scale: 1
            }} viewport={{
              once: true,
              amount: 0.3
            }} transition={{
              duration: 1.4,
              ease: [0.22, 1, 0.36, 1]
            }} className="aspect-[4/5] w-full object-cover" data-id="element-376" data-mp="1ndvdbs8la9vq" />
            </div>
          </Reveal>
        </div>

        <ul className="divide-y divide-navy-900/10 border-t border-navy-900/10" data-id="element-377" data-mp="zhzpx6kzcn87">
          {reasons.map((reason, i) => <Reveal key={reason.id} delay={i * 0.06} data-id="element-378" data-mp="1efa0mdpstp2v" data-mpi={i}>
              <li className="group grid gap-3 py-8 sm:grid-cols-[auto_1fr] sm:gap-8" data-id="element-379" data-mp="19em97qxnr684">
                <span className="font-mono text-sm text-brass" data-id="element-380" data-mp="2psm76wcy0lsq">
                  {String(i + 1).padStart(2, '0')}
                </span>
                <div data-id="element-381" data-mp="2ktj0z8l889j6">
                  <h3 className="font-display text-2xl tracking-[-0.01em] text-navy-900 transition-colors duration-300 group-hover:text-brass-dark sm:text-3xl" data-id="element-382" data-mp="2kw5671knacy8">
                    {reason.title}
                  </h3>
                  <p className="mt-3 max-w-lg text-[15px] leading-relaxed text-ink-700/70" data-id="element-383" data-mp="31vf21sc3we8u">
                    {reason.description}
                  </p>
                </div>
              </li>
            </Reveal>)}
        </ul>
      </div>
    </section>;
}